import axios from "axios";
import { PromiseHandler } from "../../handlers";
import { FilterTypes, FilterValueTypes, parseIdFilter, validateFilterStructure } from "../../handlers/filter";
import { NotImplementedError, UnsuccessfulHermesResponse, FiltersRequiredError, FilterErrorName } from "../../errors";
import { PixelLastReceivedFetchFailed, InvalidPixelLastReceivedData } from "./errors";
/**
 * Handles fetching the last received date for pixels.
 * This is an optimized alternative to Histories that only returns the most recent
 * beacon fire date per pixel, instead of all daily history.
 *
 * Returns ~1k rows instead of ~500k rows for typical orgs.
 */
class LastReceived extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "lastReceived", { atomize: true });
        this.validateResponse = (rawAxiosResponse) => {
            if (rawAxiosResponse.status < 200 || rawAxiosResponse.status > 299) {
                throw new UnsuccessfulHermesResponse(rawAxiosResponse.status);
            }
            if (!Array.isArray(rawAxiosResponse.data)) {
                throw new InvalidPixelLastReceivedData();
            }
        };
    }
    /**
     * Find the last received date for pixels based on a set of pixelIds.
     *
     * @param filters: filter by pixelIds (e.g., {where: [field: "id", type: FilterTypes.IN, value: ["1", "2", "3"]]})
     * @returns Promise resolving to array of {id, last_received} objects
     */
    async findItems(filters) {
        validateFilterStructure(filters, [
            { filterType: FilterTypes.IN, valueType: FilterValueTypes.OBJECT }
        ]);
        const filterIds = Array.from(parseIdFilter(filters));
        if (filterIds.length === 0) {
            throw new FiltersRequiredError("id");
        }
        const url = `${this.sdk.urls.baseHermesUrl}/beacon_last_received`;
        try {
            const response = await axios.post(url, {
                ids: filterIds
            }, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            this.validateResponse(response);
            return response.data;
        }
        catch (error) {
            if (error.name === FilterErrorName.FilterInvalidError) {
                throw error;
            }
            else {
                throw new PixelLastReceivedFetchFailed();
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async saveItem(item) {
        throw new NotImplementedError("save");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async deleteItem(id) {
        throw new NotImplementedError("delete");
    }
}
export default LastReceived;
//# sourceMappingURL=lastReceived.js.map